"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbOtpLogin = exports.MbOtp = exports.MbOtpBase = void 0;
// Repositories
const repository_1 = require("../../../features/authoriser/infra/repositories/repository");
const repository_2 = require("../../../features/authoriser/infra/repositories/verifyOtp/repository");
const repository_3 = require("../../../features/authoriser/infra/repositories/verifyOtpLogin/repository");
const repository_4 = require("../../../features/authoriser/infra/repositories/getOtpChannel/repository");
// Events
const events_1 = require("../../../features/events");
// Types
const types_1 = require("../../../features/authoriser/types");
// Constants
const challenges_constants_1 = require("../constants/challenges.constants");
class MbOtpBase {
    constructor(api, data) {
        this.api = api;
        this.progressId = data.progressId;
        this.data = data;
    }
}
exports.MbOtpBase = MbOtpBase;
class MbOtp extends MbOtpBase {
    constructor(api, data, urlConfig, eventBus) {
        super(api, data);
        this.doRetry = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data, httpStatus } = yield (0, repository_1.regenerateOTP)(this.api, this.progressId, this.urlConfig.retry);
                this.data = Object.assign(Object.assign({}, this.data), { otpId: data.otpId });
                if (httpStatus === challenges_constants_1.OTP_LIMIT_CUSTOM_HTTP_STATUS && (data === null || data === void 0 ? void 0 : data.errorCode) === challenges_constants_1.BUSSINESS_VALIDATION_ERROR) {
                    return types_1.ChallengeRetryStatus.LIMIT_REACHED;
                }
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP, success: true }, this.eventBus);
            }
            catch (error) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP, success: false }, this.eventBus);
            }
            return types_1.ChallengeRetryStatus.DEFAULT;
        });
        this.urlConfig = urlConfig;
        this.eventBus = eventBus;
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.fetchOtpChannel();
        });
    }
    fetchOtpChannel() {
        return __awaiter(this, void 0, void 0, function* () {
            let channel = types_1.OtpChallengeChannel.SMS;
            try {
                channel = yield repository_4.getOtpChannelRepository.get(this.api, this.progressId, this.urlConfig.otpChannel);
            }
            catch (err) {
                if (err.errorCode === challenges_constants_1.NO_TRUSTED_ERROR) {
                    channel = types_1.OtpChallengeChannel.PUSH;
                }
            }
            this.data = Object.assign(Object.assign({}, this.data), { channel });
        });
    }
    doVerify(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const verificationData = {
                id: this.data.otpId,
                value,
            };
            return repository_2.verifyOtpChallengeRepository.verify(this.api, this.progressId, verificationData, this.urlConfig.verify);
        });
    }
}
exports.MbOtp = MbOtp;
class MbOtpLogin extends MbOtpBase {
    constructor(api, data, urlConfig, eventBus) {
        super(api, data);
        this.doRetry = () => __awaiter(this, void 0, void 0, function* () {
            try {
                const { data } = yield (0, repository_1.resendOTPLogin)(this.api, this.progressId, this.urlConfig.retry);
                this.data = Object.assign(Object.assign({}, this.data), { otpId: data.otpId });
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP_LOGIN, success: true }, this.eventBus);
            }
            catch (_) {
                (0, events_1.publishResentChallengeEvent)({ challenge: types_1.ChallengeType.OTP_LOGIN, success: false }, this.eventBus);
            }
        });
        this.urlConfig = urlConfig;
        this.eventBus = eventBus;
    }
    doVerify(value) {
        return __awaiter(this, void 0, void 0, function* () {
            const verificationData = {
                id: this.data.otpId,
                value,
            };
            return repository_3.verifyOtpLoginChallengeRepository.verify(this.api, this.progressId, verificationData, this.urlConfig.verify);
        });
    }
}
exports.MbOtpLogin = MbOtpLogin;
//# sourceMappingURL=otp.js.map